// Actions
export const PLAYLIST_FETCH  = '[Playlist] Fetch'

// Mutations
export const PLAYLIST_META   = '[Playlist] meta'
export const PLAYLIST_OBTAIN = '[Playlist] obtain'
export const PLAYLIST_CLEAR  = '[Playlist] clear'
export const PLAYLIST_SET_LOADING = '[Playlist] set loading'
